module.exports = __webpack_public_path__ + "static/media/AndroidFacebookFallback1.f3d0a99d.png";